(function(){
'use strict';
var seriesMap={bmw:{e81:'1 Serie',e82:'1 Serie',e87:'1 Serie',e88:'1 Serie',f20:'1 Serie',f21:'1 Serie',f40:'1 Serie',f41:'1 Serie',f22:'2 Serie',f23:'2 Serie',f44:'2 Serie',f45:'2 Serie',f46:'2 Serie',g42:'2 Serie',u06:'2 Serie',e36:'3 Serie',e46:'3 Serie',e90:'3 Serie',e91:'3 Serie',e92:'3 Serie',e93:'3 Serie',f30:'3 Serie',f31:'3 Serie',f34:'3 Serie',f35:'3 Serie',g20:'3 Serie',g21:'3 Serie',f32:'4 Serie',f33:'4 Serie',f36:'4 Serie',g22:'4 Serie',g23:'4 Serie',g26:'4 Serie',e34:'5 Serie',e39:'5 Serie',e60:'5 Serie',e61:'5 Serie',f07:'5 Serie',f10:'5 Serie',f11:'5 Serie',g30:'5 Serie',g31:'5 Serie',g60:'5 Serie',g61:'5 Serie',e24:'6 Serie',e63:'6 Serie',e64:'6 Serie',f06:'6 Serie',f12:'6 Serie',f13:'6 Serie',g32:'6 Serie',e23:'7 Serie',e32:'7 Serie',e38:'7 Serie',e65:'7 Serie',e66:'7 Serie',e67:'7 Serie',f01:'7 Serie',f02:'7 Serie',f03:'7 Serie',f04:'7 Serie',g11:'7 Serie',g12:'7 Serie',g70:'7 Serie',e31:'8 Serie',g14:'8 Serie',g15:'8 Serie',g16:'8 Serie',e84:'X1',f48:'X1',u11:'X1',f39:'X2',u10:'X2',e83:'X3',f25:'X3',g01:'X3',g08:'X3',f26:'X4',g02:'X4',e53:'X5',e70:'X5',f15:'X5',f85:'X5',g05:'X5',e71:'X6',f16:'X6',f86:'X6',g06:'X6',g07:'X7',e85:'Z-serie',e86:'Z-serie',e89:'Z-serie',g29:'Z-serie',f87:'M2',g87:'M2',f80:'M3',g80:'M3',g81:'M3',f82:'M4',f83:'M4',g82:'M4',g83:'M4',f90:'M5',g90:'M5',g99:'M5',f91:'M8',f92:'M8',f93:'M8'},mercedes:{w176:'A-Klasse',v177:'A-Klasse',w177:'A-Klasse',w246:'B-Klasse',w242:'B-Klasse',c117:'CLA-Klasse',w117:'CLA-Klasse',x117:'CLA-Klasse',w118:'CLA-Klasse',c118:'CLA-Klasse',w203:'C-Klasse',s203:'C-Klasse',c203:'C-Klasse',w204:'C-Klasse',s204:'C-Klasse',c204:'C-Klasse',w205:'C-Klasse',s205:'C-Klasse',c205:'C-Klasse',a205:'C-Klasse',w206:'C-Klasse',s206:'C-Klasse',w211:'E-Klasse',s211:'E-Klasse',w212:'E-Klasse',s212:'E-Klasse',w207:'E-Klasse',c207:'E-Klasse',a207:'E-Klasse',w213:'E-Klasse',s213:'E-Klasse',c238:'E-Klasse',a238:'E-Klasse',w220:'S-Klasse',w221:'S-Klasse',w222:'S-Klasse',w223:'S-Klasse',w217:'S-Klasse Coupe/Cabrio',c217:'S-Klasse Coupe/Cabrio',a217:'S-Klasse Coupe/Cabrio',w218:'CLS',x218:'CLS',c257:'CLS',x257:'CLS',c236:'CLE-Klasse',a236:'CLE-Klasse',w164:'ML/GLE',w166:'GLE',v167:'GLE',c292:'GLE Coupe',c167:'GLE Coupe',x166:'GLS',x167:'GLS',x164:'GL-Klasse',w463:'G-Klasse',w465:'G-Klasse',x253:'GLC',c253:'GLC',w253:'GLC',x254:'GLC',c254:'GLC',x156:'GLA',h247:'GLA',x247:'GLB',x243:'EQB',n293:'EQC',v295:'EQE',x204:'GLK',w251:'R-Klasse',r172:'SLK/SLC',r171:'SLK/SLC',r231:'SL',r107:'SL',w447:'V-Klasse/Vito',w470:'X-Klasse',w906:'Vito/Sprinter',w907:'Sprinter',w910:'Sprinter',w214:'E-Klasse',s214:'E-Klasse',x214:'E-Klasse',w167:'GLE',a463:'G-Klasse'},audi:{a1:'A1',a3:'A3',a4:'A4',a5:'A5',a6:'A6',a7:'A7',a8:'A8',q2:'Q2',q3:'Q3',q4:'Q4',q5:'Q5',q6:'Q6',q7:'Q7',q8:'Q8',s3:'S3',s4:'S4',s5:'S5',s6:'S6',s7:'S7',s8:'S8',r8:'R8',tt:'TT','8l':'A3','8p':'A3','8v':'A3','8y':'A3','8e':'A4','8h':'A4','8k':'A4','8t':'Q5',b5:'A4',b6:'A4',b7:'A4',b8:'A4',b9:'A4',c5:'A6',c6:'A6',c7:'A6',c8:'A6','4f':'A6','4g':'A6','4k':'A6','4m':'Q7',f1:'Q8'},volkswagen:{golf:'Golf','golf 4':'Golf','golf 4.5':'Golf','golf 5':'Golf','golf 5.5':'Golf','golf 6':'Golf','golf 6.5':'Golf','golf 7':'Golf','golf 7.5':'Golf','golf 8':'Golf','golf 8.5':'Golf','golf iv':'Golf','golf v':'Golf','golf vi':'Golf','golf vii':'Golf','golf viii':'Golf',polo:'Polo',passat:'Passat',tiguan:'Tiguan',touran:'Touran',touareg:'Touareg',touareq:'Touareg',caddy:'Caddy',transporter:'Transporter',scirocco:'Scirocco',arteon:'Arteon',beetle:'Beetle',amarok:'Amarok','t-roc':'T-Roc','t-cross':'T-Cross',up:'Up'}};

function seriesOf(brandKey,code){
  var map=seriesMap[brandKey];
  if(map&&map[code])return map[code];
  if(brandKey==='volkswagen'){
    var base=String(code).split(' ')[0];
    if(!base)return 'Overig';
    return base.split('-').map(function(w){return w.charAt(0).toUpperCase()+w.slice(1);}).join('-');
  }
  return 'Overig';
}
window.empSeriesOf=seriesOf;

function setup(form){
  var bs=form.elements.merk,ss=form.elements.serie,ms=form.elements.model;
  if(!bs||!ss||!ms)return;

  var fullModels=null;
  var placeholder={value:'',text:''};
  var applyingFilter=false;
  var urlSerie=(new URLSearchParams(location.search)).get('serie')||'';
  var urlSerieConsumed=false;

  function captureFullModels(){
    var opts=Array.prototype.slice.call(ms.options);
    if(opts.length&&!opts[0].value){
      placeholder={value:opts[0].value,text:opts[0].text};
    }
    fullModels=opts.filter(function(o){return !!o.value;}).map(function(o){return {value:o.value,text:o.text};});
  }

  function rebuildSeriesOptions(){
    var brandKey=bs.value||'';
    var keepValue=ss.value;
    var values=[];
    if(brandKey&&fullModels){
      var seen={};
      fullModels.forEach(function(o){
        var s=seriesOf(brandKey,o.value);
        if(!seen[s]){seen[s]=true;values.push(s);}
      });
      values.sort(function(a,b){return a==='Overig'?1:b==='Overig'?-1:a.localeCompare(b,'nl',{numeric:true});});
    }
    ss.replaceChildren(new Option('Alle series',''));
    values.forEach(function(v){ss.add(new Option(v,v));});
    ss.disabled=!brandKey||!values.length;

    if(!urlSerieConsumed&&brandKey&&values.length){
      urlSerieConsumed=true;
      if(urlSerie&&values.indexOf(urlSerie)>-1){
        ss.value=urlSerie;
        ss.dispatchEvent(new Event('change',{bubbles:true}));
        return;
      }
    }

    if(keepValue&&values.indexOf(keepValue)>-1){
      ss.value=keepValue;
    } else if(ms.value&&brandKey){
      var derived=seriesOf(brandKey,ms.value);
      if(values.indexOf(derived)>-1)ss.value=derived;
    }
  }

  function applySeriesFilter(){
    if(!fullModels)return;
    var brandKey=bs.value||'';
    var chosen=ss.value;
    var wanted=chosen?fullModels.filter(function(o){return seriesOf(brandKey,o.value)===chosen;}):fullModels;

    var currentValues=Array.prototype.slice.call(ms.options).filter(function(o){return !!o.value;}).map(function(o){return o.value;});
    var wantedValues=wanted.map(function(o){return o.value;});
    var same=currentValues.length===wantedValues.length&&currentValues.every(function(v,i){return v===wantedValues[i];});
    if(same)return;

    var keepValue=ms.value;
    applyingFilter=true;
    ms.replaceChildren(new Option(placeholder.text,placeholder.value));
    wanted.forEach(function(o){ms.add(new Option(o.text,o.value));});

    if(keepValue&&wantedValues.indexOf(keepValue)>-1){
      ms.value=keepValue;
    } else if(ms.value!==''){
      ms.value='';
      ms.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }

  var mo=new MutationObserver(function(){
    if(applyingFilter){applyingFilter=false;return;}
    captureFullModels();
    rebuildSeriesOptions();
    applySeriesFilter();
  });
  mo.observe(ms,{childList:true});

  bs.addEventListener('change',function(){ss.value='';});
  ss.addEventListener('change',applySeriesFilter);

  captureFullModels();
  rebuildSeriesOptions();
  applySeriesFilter();
}

function init(){
  Array.prototype.forEach.call(document.querySelectorAll('.emp-finder'),setup);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
}else{
  init();
}
})();
